import React from 'react';

export function PartyPopperIcon({ className, width = 20, height = 20 }) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5126_2361)">
        <path
          d="M4.83329 9.41699L1.66663 18.3337L10.5833 15.1753"
          stroke="black"
          strokeWidth="1.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33337 2.5H3.34171"
          stroke="black"
          strokeWidth="1.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3334 6.66699H18.3417"
          stroke="black"
          strokeWidth="1.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 1.66699H12.5083"
          stroke="black"
          strokeWidth="1.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3334 16.667H18.3417"
          stroke="black"
          strokeWidth="1.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3333 1.66699L16.4666 2.29199C15.9353 2.46898 15.4819 2.82503 15.184 3.29926C14.8861 3.7735 14.7621 4.33649 14.8333 4.89199C14.9166 5.60866 14.3583 6.25033 13.625 6.25033H13.3083C12.5916 6.25033 11.975 6.75033 11.8416 7.45033L11.6666 8.33366"
          stroke="black"
          strokeWidth="1.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3333 10.8331L17.65 10.5581C16.9333 10.2748 16.1333 10.7248 16 11.4831C15.9083 12.0664 15.4 12.4998 14.8083 12.4998H14.1666"
          stroke="black"
          strokeWidth="1.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.16667 1.66699L9.44167 2.35033C9.725 3.06699 9.275 3.86699 8.51667 4.00033C7.93333 4.08366 7.5 4.60033 7.5 5.19199V5.83366"
          stroke="black"
          strokeWidth="1.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.16668 10.8334C10.775 12.4418 11.525 14.3084 10.8333 15.0001C10.1417 15.6918 8.27501 14.9418 6.66668 13.3334C5.05835 11.7251 4.30835 9.85843 5.00001 9.16676C5.69168 8.4751 7.55835 9.2251 9.16668 10.8334Z"
          stroke="black"
          strokeWidth="1.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5126_2361">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
